import { render, staticRenderFns } from "./ResultTimeBox.vue?vue&type=template&id=94da77f4&scoped=true&"
import script from "./ResultTimeBox.vue?vue&type=script&lang=js&"
export * from "./ResultTimeBox.vue?vue&type=script&lang=js&"
import style1 from "./ResultTimeBox.vue?vue&type=style&index=1&id=94da77f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94da77f4",
  null
  
)

export default component.exports